import React from "react";
import { StyledCard } from "../../style";
import Acoes from "../../components/Acoes";

const AcoesTab = () => {
  return (
    <StyledCard>
      <div className="p-4 d-flex justify-content-center">
        <Acoes />
      </div>
    </StyledCard>
  );
};

export default AcoesTab;
